import { Status } from "models/Status";
import { ObjectField } from "react3l-decorators";
import nameof from "ts-nameof.macro";
import { AppUser } from "./AppUser";

ObjectField(Status)(AppUser.prototype, nameof(AppUser.prototype.status));

export * from "./AppUser";
export * from "./AppUserFilter";

